import React, {
  forwardRef,
  useCallback,
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
  CSSProperties,
} from "react";

import {
  Expression,
  GridData,
  GridDataOptions,
  GridProps,
  Pager,
  Sorter,
} from "../../Component/schema";
import {
  getDataSource,
  getDictionaryMapper,
  getGridData,
  getPagination,
} from "../../../../../component/DataList/util";
import {
  Button,
  Icon,
  List,
  Checkbox,
  Result,
  SearchBar,
  InputItem,
  Toast,
} from "antd-mobile";
import { Space } from "antd-mobile-v5";
import { DownOutline, UpOutline } from "antd-mobile-icons";
import DictionarySelect from "../../../../../component/CheckBoxItem";
import instance from "../../../../../util/axios";

const { Item } = List;
const Brief = Item.Brief;
const CheckboxItem = Checkbox.CheckboxItem;
interface InputFields {
  uuid: string;
  quantity?: string;
  pieces?: string;
}
const TransferList = forwardRef(
  (
    {
      url,
      descriptions,
      onClickRow,
      rowSelectionType,
      pageSize = 10,
      step = 1,
    }: GridProps,
    ref: any
  ) => {
    const searchFormRef = useRef<{ [key: string]: string }>({});
    const [innerPagination, setInnerPagination] = useState<any>({});
    const [formattedData, setFormattedData] = useState<any[]>([]);
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [keyword, setKeyword] = useState<string>();
    const [keyword1, setKeyword1] = useState<string>();
    const [barWord, setBarWord] = useState<string>();
    const [barWord1, setBarWord1] = useState<string>();
    const filledStyle: CSSProperties = {
      color: "#FD5A5F",
    };
    const notFilledStyle: CSSProperties = {
      color: "black",
    };
    //新增
    /**
     * 仅查询数据
     * @param pager
     * @param currentSorter
     */
    const getData = useCallback(
      async function getData(
        pager?: Pager,
        currentSorter?: Sorter,
        keyword?: string
      ): Promise<GridData> {
        console.log(getDictionaryMapper(descriptions), "kk");
        const options: GridDataOptions = {
          url,
          dictionaryMapper: getDictionaryMapper(descriptions),
          pagination: true,
          pager: pager,
          sorter:
            currentSorter && currentSorter.order ? currentSorter : undefined,
          // searchForm: searchFormRef.current,
          searchForm: { param: keyword || "" },
          // fuzzySearch: keyword,
          fuzzySearch: "",
          innerDescriptions: descriptions,
        };

        return await getGridData(options);
      },
      [descriptions, url]
    );

    /**
     * 加载数据
     * @param pager
     * @param currentSorter
     */
    const loadData = useCallback(
      async function loadData(
        pager?: Pager,
        currentSorter?: Sorter,
        searchKeyword?: string
      ) {
        const gridData = await getData(
          pager,
          currentSorter,
          searchKeyword ? searchKeyword : keyword
        );
        gridData &&
          gridData.data &&
          gridData.data.length > 0 &&
          gridData.data.forEach((item, index) => {
            if (!item.uuid) item.uuid = (+new Date()).toString() + index;
          });
        if (gridData) {
          setInnerPagination(getPagination(gridData, gridData?.total || 10));

          const formdata = getDataSource(gridData, descriptions);
          setFormattedData((prevState) => {
            if (pager?.pageIndex === 1) {
              return formdata;
            }

            return [...prevState, ...formdata];
          });
        }
      },
      [keyword]
    );

    useEffect(() => {
      loadData({ pageIndex, pageSize: pageSize }).then();
    }, [loadData, pageIndex, pageSize]);

    // 选中行数据
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    useImperativeHandle(ref, () => ({
      getCheckedItem() {
        return selectedRows;
      },
      clearCheckedItem() {
        setSelectedRows([]);
      },
      refresh() {
        loadData({ pageIndex, pageSize: pageSize }).then();
      },
    }));

    return step === 1 ? (
      <>
        <List>
          <div style={{ width: "100%", display: "inline-flex" }}>
            <SearchBar
              style={{ width: "85%", height: 50, fontSize: 16 }}
              value={barWord}
              key="1"
              placeholder="多个条件时以逗号分割"
              maxLength={20}
              onChange={(value) => {
                setBarWord(value);
              }}
            />
            <Button
              style={{ width: "15%", height: 50, fontSize: 16 }}
              onClick={() => {
                setKeyword(barWord);
                setPageIndex(1);
              }}
            >
              查询
            </Button>
          </div>
          {rowSelectionType === "checkbox"
            ? formattedData.map((item, i) => (
                <CheckboxItem
                  style={{ marginLeft: 12 }}
                  key={item.uuid}
                  checked={selectedRows.some(
                    (selectedItem) => selectedItem.detailId === item.detailId
                  )}
                  onChange={(e: { target: { checked: any } }) => {
                    const copy = JSON.parse(JSON.stringify(selectedRows));
                    if (e.target.checked) {
                      // 选中数据时 要同步对应uuid的工作量

                      if (
                        item.amount === "" ||
                        item.amount === null ||
                        item.amount === undefined
                      ) {
                        Toast.fail("请填写数量后再选择！");
                        return;
                      }
                      copy.push(item);
                    } else {
                      const index = copy.findIndex(
                        (a: any) => a.uuid === item.uuid
                      );
                      copy.splice(index, 1); // 删除取消的选项
                      item.amount = "";
                    }
                    setSelectedRows(copy);
                  }}
                >
                  {
                    <Item wrap align="top" multipleLine>
                      <Brief
                        style={
                          item["isFilled"] == "1" ? filledStyle : notFilledStyle
                        }
                      >
                        {descriptions[0].fieldShowName!}：
                        {item[descriptions[0].fieldName!]}
                        {descriptions
                          .slice(1, descriptions.length)
                          .map((desc) => (
                            <div
                              style={{
                                whiteSpace: "normal",
                                wordBreak: "break-all",
                                overflow: "hidden",
                              }}
                            >
                              {`${desc.fieldShowName}: ${
                                item[desc.fieldName!]
                              }`}
                            </div>
                          ))}
                      </Brief>

                      <div style={{ marginLeft: -16 }}>
                        <InputItem
                          style={{ marginLeft: -6, textAlign: "left" }}
                          id={item.uuid}
                          min={0}
                          max={
                            Number(item?.produceQuantity) -
                            Number(item?.outAmount)
                          }
                          type={"number"}
                          placeholder={"请填写"}
                          value={item?.amount}
                          onChange={(value) => {
                            console.log(
                              Number(item?.produceQuantity) -
                                Number(item?.outAmount),
                              value
                            );
                            const copyFormattedData = JSON.parse(
                              JSON.stringify(formattedData)
                            );

                            copyFormattedData[i].amount = Number(value);
                            console.log(copyFormattedData);
                            setFormattedData(copyFormattedData);
                          }}
                          onBlur={(value) => {
                            console.log(
                              Number(value) >
                                Number(item?.produceQuantity) -
                                  // Number(item?.outAmount)
                                  Number(item?.saveAmount)
                            );
                            if (
                              Number(value) >
                              Number(item?.produceQuantity) -
                                // Number(item?.outAmount)
                                Number(item?.saveAmount)
                            ) {
                              // Toast.fail("本次转移数量不得大于数量-已转移数量");
                              Toast.fail("本次转移数量不得大于数量-已保存数量");
                              const copyFormattedData = JSON.parse(
                                JSON.stringify(formattedData)
                              );

                              copyFormattedData[i].amount = "";
                              setFormattedData(copyFormattedData);
                            }
                          }}
                        >
                          本次转移数量:
                        </InputItem>
                      </div>
                    </Item>
                  }
                </CheckboxItem>
              ))
            : formattedData.map((item, i) => (
                <Item
                  wrap
                  align="top"
                  multipleLine
                  onClick={() => {
                    if (onClickRow) {
                      onClickRow(item);
                    } else {
                      return;
                    }
                  }}
                >
                  {item[descriptions[0].fieldName!]}
                  <Brief>
                    {descriptions.slice(1, descriptions.length).map((desc) => (
                      <div>{`${desc.fieldShowName}: ${
                        item[desc.fieldName!]
                      }`}</div>
                    ))}
                  </Brief>
                </Item>
              ))}
        </List>
        {formattedData.length >= innerPagination.total && (
          <Button style={{ marginBottom: "50px" }}></Button>
        )}
        {formattedData.length < innerPagination.total &&
          formattedData.length !== 0 && (
            <Button
              style={{ color: "#00b578", marginBottom: "50px" }}
              onClick={() => {
                setPageIndex((prevState) => prevState + 1);
              }}
            >
              点击加载更多
            </Button>
          )}
        {formattedData.length === 0 && (
          <Result
            style={{
              height: "calc(100vh - 136px)",
            }}
            img={
              <Icon
                type="cross-circle-o"
                style={{
                  width: 60,
                  height: 60,
                  color: "#1890ff",
                }}
              />
            }
            title="暂无数据"
          />
        )}
      </>
    ) : (
      <>
        <List>
          <div style={{ width: "100%", display: "inline-flex" }}>
            <SearchBar
              style={{ width: "85%", height: 50, fontSize: 16 }}
              value={barWord1}
              key="2"
              placeholder="Search"
              maxLength={20}
              onChange={(value) => {
                setBarWord1(value);
              }}
            />
            <Button
              style={{ width: "15%", height: 50, fontSize: 16 }}
              onClick={() => {
                setKeyword1(barWord1);
              }}
            >
              查询
            </Button>
          </div>

          {selectedRows
            ?.filter((items) => {
              let flag = false;
              if (keyword1) {
                if (items?.orderNo?.includes(keyword1)) {
                  flag = true;
                }
                if (items?.dealerName?.includes(keyword1)) {
                  flag = true;
                }
                if (items?.skuName?.includes(keyword1)) {
                  flag = true;
                }
                if (items?.gear?.includes(keyword1)) {
                  flag = true;
                }
                if (items?.gearModel?.includes(keyword1)) {
                  flag = true;
                }
                if (items?.color?.includes(keyword1)) {
                  flag = true;
                }
                if (items?.formulaName?.includes(keyword1)) {
                  flag = true;
                }
              } else {
                flag = true;
              }
              return flag;
            })
            .map((item, i) => (
              <Item wrap align="top" multipleLine key={item?.uuid}>
                <Brief
                  style={item["isFilled"] == "1" ? filledStyle : notFilledStyle}
                >
                  {descriptions[0].fieldShowName!}：
                  {item[descriptions[0].fieldName!]}
                  {descriptions.slice(1, descriptions.length).map((desc) => (
                    <div
                      style={{
                        whiteSpace: "normal",
                        wordBreak: "break-all",
                        overflow: "hidden",
                      }}
                    >
                      {`${desc.fieldShowName}: ${item[desc.fieldName!]}`}
                    </div>
                  ))}
                </Brief>
                <div style={{ marginLeft: -16 }}>
                  <InputItem
                    style={{ marginLeft: -6, textAlign: "left" }}
                    id={item.uuid}
                    min={0}
                    max={
                      Number(item?.produceQuantity) - Number(item?.outAmount)
                    }
                    type={"digit"}
                    placeholder={"请填写"}
                    value={item?.amount}
                    onChange={(value) => {
                      const copySelectedRows = JSON.parse(
                        JSON.stringify(selectedRows)
                      );

                      copySelectedRows[i].amount = Number(value);
                      setSelectedRows(copySelectedRows);
                    }}
                    onBlur={(value) => {
                      if (
                        Number(value) >
                        Number(item?.produceQuantity) - Number(item?.outAmount)
                      ) {
                        Toast.fail("本次转移数量不得大于数量-已转移数量");
                        const copySelectedRows = JSON.parse(
                          JSON.stringify(selectedRows)
                        );

                        copySelectedRows[i].amount = "";
                        setSelectedRows(copySelectedRows);
                      }
                    }}
                  >
                    本次转移数量:
                  </InputItem>
                </div>
              </Item>
            ))}
        </List>
      </>
    );
  }
);

export default TransferList;
